import React from 'react';
const ConversationDots = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      className={color}
      {...props}
    >
      <rect width="30" height="30" rx="4" fill="#DFF4FF" />
      <path
        d="M11 15H11.009M14.991 15H15M18.991 15H19"
        stroke={color}
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15 25C20.5228 25 25 20.5228 25 15C25 9.47715 20.5228 5 15 5C9.47715 5 5 9.47715 5 15C5 16.5997 5.37562 18.1116 6.04346 19.4525C6.22094 19.8088 6.28001 20.2161 6.17712 20.6006L5.58151 22.8267C5.32295 23.793 6.20701 24.677 7.17335 24.4185L9.39939 23.8229C9.78393 23.72 10.1912 23.7791 10.5475 23.9565C11.8884 24.6244 13.4003 25 15 25Z"
        stroke={color}
        stroke-width="1.4"
      />
    </svg>
  );
};

export default ConversationDots;
